{
  "hero": {
    "title": "Boost Innovation",
    "description": "Automation-focused bright ideas submitted by CGI members. This view filters the Boost Innovation backlog down to items that mention Automation in the title or description and surfaces who proposed them, who leads them, and when they were submitted.\n",
    "actions": [
      {
        "label": "Open bright ideas portal",
        "href": "https://pgdcinnovate.groupinfra.com/bright_ideas/",
        "variant": "solid"
      }
    ],
    "heroImage": "/assets/img/hero-image.png",
    "heroImageAlt": "D&AS hero art"
  },
  "api": {
    "remoteUrl": "/api/boost-api",
    "localProxyUrl": "/api/boost-api"
  },
  "ui": {
    "ideasTitle": "Project Ideas",
    "searchPlaceholder": "Label",
    "advancedFilters": "Advanced filters",
    "filtersTitle": "Filters",
    "filtersSearchPlaceholder": "Search by filter criteria",
    "categoryLabel": "Category",
    "departmentLabel": "Department",
    "creationDateLabel": "Creation date",
    "startDatePlaceholder": "Start date",
    "endDatePlaceholder": "End date",
    "clearLabel": "Clear",
    "cancelLabel": "Cancel",
    "applyLabel": "Apply",
    "emptyData": "Boost Innovation data not found.",
    "emptyList": "No ideas match the current filters."
  },
  "statusTabs": [
    "All",
    "Submitted",
    "In Review",
    "Approved",
    "In Development",
    "Completed",
    "Denied"
  ],
  "details": {
    "sections": [
      "Overview",
      "Implementation Details",
      "Submitter Details",
      "Status Timeline",
      "Submission Metadata"
    ]
  }
}